import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResults070925 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination Results 07/09/2025</h3>
      <br />
      <br />



        <div><Link to='/conduct-naruporns'>1. AAT  2339  MR.NARUPORN  SAOWANIT(Pass with Distinction)---Acquired Rank 3DAN</Link></div>
        <br />
        <div><Link to='/conduct-pongnarts'>2. AAT  6856  MR.PONGNART SAPSOMPONG(Pass)---Acquired Rank 1DAN </Link></div>
        <br />
        <div><Link to='/conduct-chaiyutv'>3. AAT  8017  MAJ.GEN CHAIYUT VAJIRAVARABHAKTI(Pass Evaluation)---SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-suteed'>4. AAT  8023  COL.SUTEE DUANGTOON(Pass Evaluation)---SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-santis'>5. AAT  7518  MR.SANTI SIRISAK(Pass with Distinction)---Acquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-pawanratc'>6. ATT  7731  MS.PAWANRAT CHUPINIJSAK(Pass with Distinction)---Acquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>7. AAT  7951  MS.NAPASANUN VONGVIVAT(Pass)---Acquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>8. AAT  7952  MS.ISSARIYAPA ROOPSUWANNAKUL(Pass)---Acquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>9. AAT  8007  MR.KARNT SRISUWAN(Pass)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>10. AAT  8008  MR.PAKAWAD NANTAJURAPLO(Pass)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-marcop'>11. AAT  8018  MR.MARCO PENNA(Pass)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-shinehl'>12. AAT  8019  MR.SHINE HTET LINN(Pass)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-suphatchayab'>13. AAT  8020  MS.SUPHATCHAYA BOONYASUKANON(Pass)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>14. AAT  8021  MS.VU NGUYEN QUYNH TRAM(Pass)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-chakchaia'>15. AAT  8022  MR.CHAKCHAI ANUPONGPAT(Pass)---Acquired Rank 10KYU</Link></div>
        <br />



        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResults070925;
